//Public function used across the whole client-side app to create logs
export function AppLog(...data: (any | undefined)[]) {
  const environment = process.env.REACT_APP_ENVIRONMENT;

  if(data === undefined || data.length === 0) { //if no data is present, throw an error
      console.log("Incorrect usage of AppLog(), there must be data present to create a log");
  }
  else {
    // Get the calling location (file and line number)
    const getCallerInfo = () => {
      try {
        const stack = new Error().stack;
        if (stack) {
          const stackLines = stack.split('\n');
          // The caller is typically at index 2 (0: Error, 1: AppLog, 2: actual caller)
          const callerLine = stackLines[2];
          
          if (callerLine) {
            // Parse different browser stack trace formats
            let match;
            
            // Chrome/Edge format: at functionName (file:line:column) or at file:line:column
            match = callerLine.match(/at.*?(?:\((.+?):(\d+):(\d+)\)|(\/.+?):(\d+):(\d+))/);
            if (match) {
              const file = match[1] || match[4];
              const line = match[2] || match[5];
              if (file && line) {
                const fileName = file.split('/').pop() || file.split('\\').pop();
                return `${fileName}:${line}`;
              }
            }
            
            // Firefox format: functionName@file:line:column
            match = callerLine.match(/@(.+?):(\d+):(\d+)/);
            if (match) {
              const file = match[1];
              const line = match[2];
              const fileName = file.split('/').pop() || file.split('\\').pop();
              return `${fileName}:${line}`;
            }
            
            // Safari format or fallback
            match = callerLine.match(/(\/.+?):(\d+):(\d+)/);
            if (match) {
              const file = match[1];
              const line = match[2];
              const fileName = file.split('/').pop() || file.split('\\').pop();
              return `${fileName}:${line}`;
            }
          }
        }
      } catch (error) {
        // If parsing fails, return a fallback
        return 'unknown:0';
      }
      return 'unknown:0';
    };

    const callerInfo = getCallerInfo();
    
    if (environment === 'production') {
      //TODO: add firebase log mechanism
    }
    else {
      console.log(`[${callerInfo}]`, ...data);

      //NOTE: Uncomment this line if you want to add the stack trace
      //console.trace();
    }
  }
}